import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetSolicitudPrestacionesEspecialesByID = {
  status: number | null;
  statusText: string | null;
};

const useGetSolicitudPrestacionesEspecialesByID = () => {
  const [loadingGetSolicitudPrestacionesEspecialesByID, setLoadingGetSolicitudPrestacionesEspecialesByID] = useState(false);
  const [successGetSolicitudPrestacionesEspecialesByID, setSuccessGetSolicitudPrestacionesEspecialesByID] = useState(false);
  const [errorGetSolicitudPrestacionesEspecialesByID, setErrorGetSolicitudPrestacionesEspecialesByID] = useState<any>(null);
  const [dataGetSolicitudPrestacionesEspecialesByID, setDataSolicitudPrestacionesEspeciales] = useState<any>(null);

  const [statusGetSolicitudPrestacionesEspecialesByID, setStatusGetSolicitudPrestacionesEspecialesByID] =
    useState<StatusGetSolicitudPrestacionesEspecialesByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getSolicitudPrestacionesEspecialesByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetSolicitudPrestacionesEspecialesByID(true);
    setSuccessGetSolicitudPrestacionesEspecialesByID(false);
    setErrorGetSolicitudPrestacionesEspecialesByID(null);

    try {
      const res = await apiRecord.getSolicitudComisionPrestacionesEspecialesByID(
        userId,
        prestacionId,
        id
      );

      setStatusGetSolicitudPrestacionesEspecialesByID({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetSolicitudPrestacionesEspecialesByID(true);
      setDataSolicitudPrestacionesEspeciales(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetSolicitudPrestacionesEspecialesByID({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetSolicitudPrestacionesEspecialesByID(err);
      console.error("Error en getSolicitudPrestacionesEspecialesByID:", err);

      throw err;

    } finally {
      setLoadingGetSolicitudPrestacionesEspecialesByID(false);
    }
  };

  return {
    getSolicitudPrestacionesEspecialesByID,
    loadingGetSolicitudPrestacionesEspecialesByID,
    successGetSolicitudPrestacionesEspecialesByID,
    errorGetSolicitudPrestacionesEspecialesByID,
    dataGetSolicitudPrestacionesEspecialesByID,
    statusGetSolicitudPrestacionesEspecialesByID
  };
};

export default useGetSolicitudPrestacionesEspecialesByID;
